import React from "react";

const ContentProducersBlank = () =>{
    return(
        <div className="blankpageContainer">

        </div>
    );
}
export default ContentProducersBlank;